// extracted by mini-css-extract-plugin
export default {"head":"index_head_7zZEH","moreTitle":"index_moreTitle_4aJrd","active":"index_active_mciUK","singleTitle":"index_singleTitle_IAGWU"};